module.exports = __webpack_public_path__ + "img/1746605070_nrfB.8c86cd33.png";